import { Link } from '@change-corgi/design-system/components/actions';
import { Avatar } from '@change-corgi/design-system/components/media';
import { Flex } from '@change-corgi/design-system/layout';
import { Text } from '@change-corgi/design-system/typography';

import type { Comment } from 'src/app/pages/petition/comments/pageContext';

import { useCommentHeader } from './hooks/useCommentHeader';

type Props = {
	comment: Comment;
};

export function CommentHeader({ comment }: Props) {
	const {
		data: { author, authorUrl, authorAvatar, dateRelative },
	} = useCommentHeader(comment);

	return (
		<Flex sx={{ alignItems: 'center' }}>
			<Avatar src={authorAvatar} variant="subtle" size={40} alt="" data-qa="comment-avatar" />
			<Flex sx={{ flexDirection: 'column', flex: 1 }}>
				<Text size="caption" ellipsis sx={{ flex: 1 }} data-qa="comment-author" pl={16}>
					{authorUrl ? <Link to={authorUrl}>{author}</Link> : author}
				</Text>
				<Text size="caption" ellipsis sx={{ flex: 1 }} pl={16} data-qa="comment-date">
					{dateRelative}
				</Text>
			</Flex>
		</Flex>
	);
}
